/* eslint-disable react/display-name */
import React from 'react';
import { Switch } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';

import { ADMIN_ROUTES } from '../constants/router';

import AuthRoute from './AuthRoute';
import Menu from '../component/Menu';
import Homepage from '../container/Home/index';
import Dashboard from '../container/Dashboard/index';
import ForgetPasswordRoutes from './forget.route';
import ProfileRoutes from './profile.route';
import Header from '../component/Header';
import StudentRoutes from './student.route';
import DocumentRoutes from './document.route';
import SeriRoutes from './seri.route';
import PermissionRoutes from './permission.route';
import ClubRoutes from './club.route';
import BranchRoutes from './branch.route';
import CompetitonRoutes from './competition.route';
import ExamRoutes from './exam.route';
import EventRoutes from './event.route';
import CourseRoutes from './course.route';
import DonateRoutes from './donate.route';
import AdsRoute from './ads.route';
import FormRoute from './form.route';
import PostWebRoute from './postweb.route';
import BannerRoute from './banner.route';
import DocumentInfoRoutes from './document-info.route';
import LibrariesRoutes from './libraries.route';
import FinancialRoute from './financial.route';

import 'react-notifications/lib/notifications.css';

export const routes = [
  // Home page
  {
    path: '/',
    component: () => <Dashboard />,
    exact: true
  },
  {
    path: ADMIN_ROUTES.HOME_PAGE,
    component: () => <Dashboard />,
    exact: true,
    meta: {
      action: 'dashboard_management',
      subject: 'dashboard'
    }
  },
  {
    path: ADMIN_ROUTES.FORGOT_PASSWORD,
    component: () => <ForgetPasswordRoutes />
  },
  {
    path: ADMIN_ROUTES.PROFILE,
    component: () => <ProfileRoutes />
  },

  {
    path: ADMIN_ROUTES.STATISTICAL_STUDENT,
    component: () => <StudentRoutes />
  },
  {
    path: ADMIN_ROUTES.STATISTICAL_CLUB,
    component: () => <ClubRoutes />
  },
  {
    path: ADMIN_ROUTES.STATISTICAL_BRANCH,
    component: () => <BranchRoutes />
  },

  {
    path: ADMIN_ROUTES.ACTIVE_DOCUMENTS,
    component: () => <DocumentRoutes />
  },
  {
    path: ADMIN_ROUTES.ACTIVE_SERI,
    component: () => <SeriRoutes />
  },
  {
    path: ADMIN_ROUTES.ACTIVE_COURSE,
    component: () => <CourseRoutes />
  },
  {
    path: ADMIN_ROUTES.ACTIVE_COMPETITION,
    component: () => <CompetitonRoutes />
  },
  {
    path: ADMIN_ROUTES.ACTIVE_EVENT,
    component: () => <EventRoutes />
  },
  {
    path: '/document',
    component: () => <DocumentInfoRoutes />
  },
  {
    path: '/active/libraries',
    component: () => <LibrariesRoutes />
  },
  {
    path: '/setting/permission',
    component: () => <PermissionRoutes />
  },
  {
    path: '/setting/exam',
    component: () => <ExamRoutes />
  },
  {
    path: '/donate',
    component: () => <DonateRoutes />
  },
  {
    path: '/ads',
    component: () => <AdsRoute />
  },
  {
    path: '/form',
    component: () => <FormRoute />
  },
  {
    path: '/postweb',
    component: () => <PostWebRoute />
  },
  {
    path: '/banner',
    component: () => <BannerRoute />
  },

  {
    path: '/financial',
    component: () => <FinancialRoute />
  }
];

const HomeRoutes = () => {
  if (typeof window !== 'undefined') {
    return (
      <>
        <NotificationContainer />
        <Menu />
        <div className="body-right" id="page-wrapper">
          <Header />
          <Switch>
            {routes.map((route) => (
              <AuthRoute key={route.path} {...route} />
            ))}
          </Switch>
        </div>
      </>
    );
  }
  return '';
};

export default HomeRoutes;
